import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { ComponentLoader } from '../../global/ComponentLoader/ComponentLoader';

const importFunc = () => {
    return import(/* webpackChunkName: "PdpSharedTradeRewardsBenefitCardChunk" */
    './PdpSharedTradeRewardsBenefitCard').then(
        ({ PdpSharedTradeRewardsBenefitCard }) => PdpSharedTradeRewardsBenefitCard
    );
};

export function PdpSharedTradeRewardsBenefitCardLoaderComponent(props) {
    const { user } = props;

    return <ComponentLoader importFunc={importFunc} load useLoadingComponent={false} user={user} />;
}

PdpSharedTradeRewardsBenefitCardLoaderComponent.propTypes = {
    user: PropTypes.object,
};

export const PdpSharedTradeRewardsBenefitCardLoader = createFragmentContainer(
    PdpSharedTradeRewardsBenefitCardLoaderComponent,
    {
        user: graphql`
            fragment PdpSharedTradeRewardsBenefitCardLoader_user on User {
                ...PdpSharedTradeRewardsBenefitCard_user
            }
        `,
    }
);
